(function() {
  var ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.StepHandler = (function(superClass) {
    extend(StepHandler, superClass);

    function StepHandler() {
      return StepHandler.__super__.constructor.apply(this, arguments);
    }

    StepHandler.prototype.inputSel = 'input';

    StepHandler.prototype.init = function() {
      var ref;
      this.layoutID = '#spp_body';
      this.layoutSelector = this.parent.dialog.find(this.layoutID);
      this.sidebar = this.parent.parent;
      this.inputChanged = false;
      this.firstLoad = true;
      if (((ref = this.response) != null ? ref.view : void 0) != null) {
        this.layoutSelector.html(this.response.view);
        return setTimeout((function(_this) {
          return function() {
            return _this.afterLoadLayout(_this.layoutSelector, _this.response);
          };
        })(this));
      } else {
        this.layoutUrl = 'backend/grower/placement/spp/load-step';
        this.loadLayoutPostOptions = {
          id: this.parent.sppID,
          result_id: this.parent.resultID,
          step_id: this.id
        };
        return this.loadLayout();
      }
    };

    StepHandler.prototype.moveStepContent = function() {
      var footer, header, modalBody, stepFooter;
      header = this.layoutSelector.find('.spp_header');
      $('#spp_header').empty().append(header);
      footer = this.layoutSelector.find('.spp_footer');
      $('#spp_footer').empty().append(footer);
      stepFooter = this.layoutSelector.find('.spp_step_footer');
      $('#spp_step_footer').remove();
      if (stepFooter.length) {
        modalBody = $('#spp_body').closest('.modal-body');
        return $('<div id="spp_step_footer"></div>').insertAfter(modalBody).append(stepFooter);
      }
    };

    StepHandler.prototype.afterLoadLayout = function(sel, response) {
      var ref;
      if (((ref = response.status) != null ? ref.type : void 0) == null) {
        return;
      }
      this.moveStepContent();
      this.parent._handleResize();
      this.validator = new ValidationEngine();
      this.getInputEl().on('change', (function(_this) {
        return function() {
          return _this.inputChanged = true;
        };
      })(this));
      this.parent.dialog.find('#back_button').on('click', (function(_this) {
        return function() {
          return _this.parent.goToStep(_this.num - 1);
        };
      })(this));
      this.parent.dialog.find('#next_button').on('click', (function(_this) {
        return function() {
          _this.toStep = _this.num + 1;
          return _this.validator.validateAll();
        };
      })(this));
      if (typeof this.customAfterLoadLayout === "function") {
        this.customAfterLoadLayout();
      }
      this.msg = $(this.parent.layoutSelector).find('.message_writer').message_writer({
        autoHide: false,
        hideTime: 10000
      });
      this.applyFieldsAspects();
      this.display_name = this.parent.taffyObjects.steps().filter({
        id: this.id
      }).first().display_name;
      this.validator.makeFormValidator('placement', '.validationContainer', '.errorDiv', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.parent.goToStep(_this.toStep);
          }
        };
      })(this));
      this.addValidationRules();
      this.sidebar.stepListKO.setCurrent(this.id);
      return this.getInputEl().first().focus();
    };

    StepHandler.prototype.applyFieldsAspects = function() {
      var aspect, field, field_aspect, fieldsAspects, sppFields, stepAspects, stepFields;
      stepFields = this.taffyObjects.fields;
      sppFields = this.parent.taffyObjects.fields;
      fieldsAspects = this.parent.taffyObjects.fieldsAspects;
      stepAspects = this.getStepAspects();
      if (this.num === 1 && stepAspects().count() > 0) {
        field = sppFields().first();
        aspect = stepAspects().first();
        field_aspect = {
          fields_id: field.id,
          aspects_id: aspect.aspects_id,
          value: this.parent.operators_id
        };
        return this.setFieldAspect(field_aspect);
      } else if (stepAspects().count() > 0) {
        return stepFields().each((function(_this) {
          return function(field) {
            return stepAspects().each(function(aspect) {
              var fieldAspect;
              fieldAspect = fieldsAspects({
                fields_id: field.id,
                aspects_id: aspect.aspects_id
              }).last();
              if (fieldAspect == null) {
                return;
              }
              return _this.setFieldAspect(fieldAspect);
            });
          };
        })(this));
      } else {
        return sppFields().each((function(_this) {
          return function(field) {
            return _this.setFieldAspect(field);
          };
        })(this));
      }
    };

    StepHandler.prototype.updateFieldsAspects = function() {
      var field, fieldNum, fieldsAspects, i, len, markVisitedSteps, ref, result, sppFields, step, stepAspect, stepAspects, stepFields;
      stepAspects = this.getStepAspects();
      stepFields = this.taffyObjects.fields;
      sppFields = this.parent.taffyObjects.fields;
      fieldsAspects = this.parent.taffyObjects.fieldsAspects;
      stepAspects().each((function(_this) {
        return function(stepAspect) {
          return fieldsAspects({
            aspects_id: stepAspect.aspects_id
          }).remove();
        };
      })(this));
      if (this.num === 1 && stepAspects().count() > 0) {
        field = sppFields().first();
        stepAspect = stepAspects().first();
        result = this.getFieldAspect(field.id, stepAspect.aspects_id);
        if (result.value != null) {
          this.parent.operators_id = result.value;
          return this.parent.operator_name = result.option_name;
        } else {
          this.parent.operators_id = null;
          return this.parent.operator_name = null;
        }
      } else if (stepAspects().count() > 0) {
        return sppFields({
          selected: true
        }).each((function(_this) {
          return function(field) {
            var skip;
            skip = !stepFields({
              id: field.id
            }).count();
            return stepAspects().each(function(stepAspect) {
              var defaultResult;
              defaultResult = {
                fields_id: field.id,
                field_name: field.display_name,
                aspects_id: stepAspect.aspects_id,
                aspect_name: stepAspect.aspect_name,
                display_name: stepAspect.display_name,
                value: null,
                options_id: null,
                option_name: null,
                skip: skip,
                steps_id: _this.id,
                step_name: _this.display_name
              };
              result = _this.getFieldAspect(field.id, stepAspect.aspects_id);
              return fieldsAspects.insert($.extend(defaultResult, result));
            });
          };
        })(this));
      } else if (this.num === 1 || this.num === 2) {
        fieldNum = 0;
        markVisitedSteps = false;
        sppFields().each((function(_this) {
          return function(field) {
            if (_this.getFieldAspect(field.id)) {
              if (!sppFields({
                id: field.id
              }).first().selected) {
                markVisitedSteps = true;
              }
              return sppFields({
                id: field.id
              }).update({
                selected: true,
                field_num: fieldNum++
              });
            } else {
              return sppFields({
                id: field.id
              }).update({
                selected: false,
                field_num: null
              });
            }
          };
        })(this));
        if (markVisitedSteps) {
          ref = this.parent.taffyObjects.steps().get();
          for (i = 0, len = ref.length; i < len; i++) {
            step = ref[i];
            if (step.step_order > this.num) {
              step.visited(false);
            }
          }
          return $.post('backend/grower/placement/spp/mark-highest-visited-step', {
            result_id: this.parent.resultID,
            step_id: this.num
          });
        }
      }
    };

    StepHandler.prototype.getStepAspects = function() {
      var xArray, yArray;
      yArray = this.taffyObjects.axes({
        name: 'Y'
      }).first().array;
      if (yArray === 'y_aspects') {
        return this.taffyObjects.y_aspects;
      }
      xArray = this.taffyObjects.axes({
        name: 'X'
      }).first().array;
      if (xArray === 'x_aspects') {
        return this.taffyObjects.x_aspects;
      }
      return new TAFFY();
    };

    StepHandler.prototype.addValidationRules = function() {};

    StepHandler.prototype.setFieldAspect = function(fieldAspect) {};

    StepHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      return {};
    };

    StepHandler.prototype.getInputEl = function(dataAttrs) {
      var attr, dataAttrStr, val;
      if (dataAttrs == null) {
        dataAttrs = {};
      }
      dataAttrs.step = this.num;
      dataAttrStr = '';
      for (attr in dataAttrs) {
        val = dataAttrs[attr];
        dataAttrStr += "[data-" + attr + "=\"" + val + "\"]";
      }
      return this.layoutSelector.find(this.inputSel + dataAttrStr);
    };

    return StepHandler;

  })(Handler);

}).call(this);
